import { DialogCloseEvent } from '@theme/dialog';

const STORAGE_KEY = 'visitor-signup-modal';

function initVisitorModal() {
  const dialog = document.getElementById('visitor-signup-modal');
  if (!dialog || typeof dialog.showDialog !== 'function') return;

  const delayMs = Math.max(0, Number(dialog.dataset.delayMs) || 0);
  const designMode = dialog.dataset.designMode === 'true';
  const skipAuto = dialog.dataset.skipAuto === 'true';

  const persistDismiss = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore quota / private mode */
    }
  };

  dialog.addEventListener(DialogCloseEvent.eventName, persistDismiss);

  const open = () => {
    dialog.showDialog();
  };

  const flashMessage = dialog.querySelector(
    '#visitor-signup-modal-errors, .visitor-signup-modal__message--success',
  );
  if (flashMessage) {
    queueMicrotask(open);
    return;
  }

  if (designMode || skipAuto) return;

  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
  } catch {
    /* treat as no storage */
  }

  setTimeout(open, delayMs);
}

function boot() {
  customElements.whenDefined('dialog-component').then(initVisitorModal);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
